import { Factory } from 'fishery';

import { Space } from '../space';

export const spaceFactory = Factory.define<Space>(({ sequence }) => ({
	id: `space-${sequence}`,
	name: `Space ${sequence}`,
	creationDate: new Date(),
	health: {
		worstSeverity: undefined
	}
}));
